import { deserializeError } from "@lifeat/shared/error/SharedError";
import { ActionName, MonolithSpecs } from "@lifeat/shared/firebase/monolith";
import { functions } from "@firebase-local/firebase";
import { logError, logWarn } from "@service/ConsoleLoggerService";
import { ClientOfflineError } from "../errors/CommonErrors";

export async function callMonolith<TName extends ActionName>(
    name: TName,
    payload: MonolithSpecs[TName]["payload"],
): Promise<MonolithSpecs[TName]["response"]> {
    if (!isOnline) {
        logWarn(`Action ${name} not called because client is offline`);
        throw new ClientOfflineError();
    }

    // Client is online, we attempt calling the function.
    const callableFunction = functions.httpsCallable("monolith");
    try {
        const request = {
            name,
            payload,
        };
        const rawResponse = await callableFunction(request);
        const response: MonolithSpecs[TName]["response"] = rawResponse.data;
        return response;
    } catch (error: unknown) {
        logError(`Error calling ${name}: ${String(error)}`);
        throw deserializeError(error);
    }
}

export async function requestFunction(name: string, body?: unknown) {
    const usingEmulator = window.location.origin.includes("localhost");
    const url = usingEmulator
        ? `http://localhost:5001/${process.env.FIREBASE_PROJECT_ID}/us-central1/${name}`
        : `https://us-central1-${process.env.FIREBASE_PROJECT_ID}.cloudfunctions.net/${name}`;
    const res = body
        ? await fetch(url, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify(body),
          })
        : await fetch(url);
    const resBody = await res.json();
    return resBody;
}

function isOnline(): boolean {
    return navigator.onLine;
}
